import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const ETabsIds = {
	basicInformation: 'basic_information',
	checkFor: 'check_for',
	condition: 'condition',
	schedule: 'schedule',
	recipient: 'recipient',
	channel: 'channel',
} as const;

export type TTabsIds = TValueOfStringRecord<typeof ETabsIds>;
